import React, { useState, useEffect, useRef } from 'react';
import { Box, Button, InputAdornment, TextField } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import { useForm, Controller } from 'react-hook-form';
import { history, useLocation } from 'umi';
import { useDispatch, useSelector } from 'dva';
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import { fmtThousand } from '@/utils/comUtil';
import BasicML from './components/BasicML';
import DetailML from './components/DetailML';
import Loading from '@/components/LoadingML/LoadingML';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import TitleML from './components/TitleML';
import {
  createId,
  createObj,
  createPersonObj,
  initDetailForm,
  tagDomeItem,
  tagDom,
  personDomItem,
  personDom,
  initValueFieldIds,
  getFormData,
} from './constants';
import { CheckBoxFieldCom } from './components/FormType';
import webStorage from '@/utils/storageManager';
import LabelStyles from './LabelStyles';

export default () => {
  // 用户菜单权限
  const userAuths = webStorage.get('USER')?.authorities;
  const dispatch = useDispatch();
  const location = useLocation();
  const { query } = location;
  const queryType = query?.opt;
  const tagId = query.tagId ? Number(query.tagId) : null;
  const [tagCollectionInfo, setTagCollectionInfo] = useState(null);
  const [deleteIds, setDeleteIds] = useState([]); //删除的id
  const [submitStatus, setSubmitStatus] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [saveOpen, setSaveOpen] = useState({
    tips: '',
    status: false,
    title: '',
  });
  const [predictLoading, setLoading] = useState(false);
  const [predictNum, setPredictNum] = useState(0);
  const [rule, setRule] = useState(false);
  const submitRef = useRef();
  const predictRef = useRef();
  const { ruleLabelDirectoryList } = useSelector(
    (state) => state.crowdCreateCopy,
  );
  const {
    handleSubmit,
    control,
    errors,
    getValues,
    setValue,
    setError,
    clearErrors,
    watch,
  } = useForm();
  const isLimitNumberDownloadWatch = watch('isLimitNumberDownload');
  const isTagCollectionInfoWatch = watch('tagCollectionInfo');
  const isTagCollectionRuleInWatch = watch('tagCollectionRuleIn');
  const loadingEffect = useSelector((state) => state.loading);
  const loading =
    loadingEffect.effects['crowdCreateCopy/selectOption'] ||
    loadingEffect.effects['crowdCreateCopy/queryTagAndRule'] ||
    loadingEffect.effects['crowdCreateCopy/getQueryTagOperatorValue'] ||
    loadingEffect.effects['crowdCreateCopy/getTreeTags'] ||
    loadingEffect.effects['crowdCreateCopy/queryFileList'];
  const handleClickOpen = () => {
    if (queryType === 'detail') {
      history.goBack();
      return;
    }
    setSaveOpen({
      status: true,
      tips: '退出后将不保存设置内容，确定要退出吗？',
      title: '退出',
    });
  };

  const onSubmitError = () => {
    setSubmitStatus(true);
    window.message.toast({
      type: 'error',
      message: '输入有误',
    });
  };
  const onSubmitSuccess = (data) => {
    if (!submitStatus) {
      return;
    }
    setIsLoading(true);
    setSubmitStatus(false);
    const postData = {};
    postData.id = tagId ? tagId : null;
    postData.title = data.title;
    postData.titleEn = '';
    postData.remark = data.remark;
    postData.type = 2;
    postData.status = 1;
    postData.isLimitNumberDownload = data.isLimitNumberDownload;
    postData.limitNumberQuantity = data.limitNumberQuantity;
    postData.predictQuantity = predictNum;
    postData.updateStrategy = Number(data.updateStrategy);
    const newTagCollectionInfo = JSON.parse(JSON.stringify(tagCollectionInfo));
    const profileGroupRule = getFormData(newTagCollectionInfo, tagId);
    postData.profileGroupRule = profileGroupRule;
    window.NE_DAWN.trigger(submitRef.current, {
      event: '_ec', // 事件名
      params: { ...postData }, // 事件公参
    });
    dispatch({
      type: 'crowdCreateCopy/insertOrUpdateGroupAndRule',
      payload: {
        values: postData,
      },
      callback: (code) => {
        if (code === 0) {
          window.message.toast({
            type: 'success',
            message: !tagId ? '新增成功' : '编辑成功',
            title: '成功',
          });
          history.goBack();
        }
        setIsLoading(false);
        setSubmitStatus(true);
      },
    });
  };
  useEffect(() => {
    //默认不出现一条条件范围
    !tagId && setTagCollectionInfo([initDetailForm()]);
    !tagId && setValue('tagCollectionInfo', '');
    !tagId && setValue('tagCollectionRuleIn', '');
    !tagId && setValue('updateStrategy', '1');
    !tagId && setValue('status', '2');
  }, [setValue, tagId]);
  useEffect(() => {
    const fetch = async () => {
      let directoryList = null;
      let treeTags = null;
      await dispatch({
        type: 'crowdCreateCopy/queryFileList',
        payload: {
          values: {
            id: tagId,
          },
        },
        callback: (list) => {
          directoryList = list;
        },
      });
      await dispatch({
        type: 'crowdCreateCopy/getQueryTagOperatorValue',
        payload: {
          values: {},
        },
        callback: () => {},
      });
      await dispatch({
        type: 'crowdCreateCopy/getTreeTags',
        payload: {
          values: {
            status: 2,
          },
        },
        callback: (list) => {
          treeTags = list;
        },
      });
      if (tagId) {
        await dispatch({
          type: 'crowdCreateCopy/queryTagAndRule',
          payload: {
            values: {
              groupId: tagId,
            },
          },
          callback: (data) => {
            const newData = JSON.parse(JSON.stringify(data));
            const updateStrategy = String(newData.updateStrategy);
            setValue('title', newData.title);
            setValue('remark', newData.remark);
            setValue('updateStrategy', updateStrategy);
            setValue('isLimitNumberDownload', newData.isLimitNumberDownload);
            setValue('limitNumberQuantity', newData.limitNumberQuantity);
            setPredictNum(newData.predictQuantity);
            const newProfileGroupRule =
              newData.profileGroupRule.length > 0
                ? [
                    {
                      tagCollectionRule: newData.profileGroupRule,
                      id: createId(),
                    },
                  ]
                : [initDetailForm()];
            if (newProfileGroupRule.length > 0) {
              newProfileGroupRule.forEach((item) => {
                let tagCollectionRuleIn = [];
                let tagCollectionRuleOut = [];
                item.tagCollectionRule.forEach((rules) => {
                  if (rules.outsideData) {
                    rules.outsideData.forEach((it) => {
                      it.id = createId();
                      it.withinItem.forEach((x) => {
                        x.id = createId();
                        x.originalDataList.forEach((y) => {
                          const initList =
                            y.originalDataType === 2 ? directoryList : treeTags;
                          y.tagIds = initValueFieldIds(y.tagIds, initList);
                          const tId = y.tagIds[y.tagIds.length - 1]?.id;
                          const fileCodeEnumGroupType =
                            y.tagIds[y.tagIds.length - 1]
                              ?.fileCodeEnumGroupType;
                          const selectIsMultiple =
                            y.tagIds?.length > 0 &&
                            [1, 5].includes(
                              y.tagIds?.[y.tagIds.length - 1]?.ruleType,
                            );
                          if (
                            !fileCodeEnumGroupType &&
                            selectIsMultiple &&
                            y.originalDataType === 1
                          ) {
                            dispatch({
                              type: 'crowdCreateCopy/selectOption',
                              payload: {
                                values: {
                                  tagId: tId,
                                },
                              },
                              callback: (res1) => {
                                if (res1.code === 0) {
                                  const collect =
                                    res1.data.tagCollectionInfo?.map((m) => ({
                                      ...m,
                                      id: String(m.id),
                                    })) || [];
                                  y.collectArr = collect;
                                  setTagCollectionInfo([
                                    ...newProfileGroupRule,
                                  ]);
                                }
                              },
                            });
                          }
                        });
                      });
                    });
                    if (rules.type === 1) {
                      tagCollectionRuleIn = rules.outsideData.map((i) => {
                        return { ...i, id: createId() };
                      });
                    } else {
                      tagCollectionRuleOut = rules.outsideData.map((i) => {
                        return { ...i, id: createId() };
                      });
                    }
                  }
                });
                item.tagCollectionRuleIn = tagCollectionRuleIn;
                item.tagCollectionRuleOut = tagCollectionRuleOut;
                delete item.tagCollectionRule;
              });
            }
            setTagCollectionInfo([...newProfileGroupRule]);
            setValue(
              'tagCollectionInfo',
              JSON.stringify([...newProfileGroupRule]),
            );
            setValue(
              'tagCollectionRuleIn',
              JSON.stringify([...newProfileGroupRule]),
            );
          },
        });
      }
    };
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, tagId]);
  // console.log('tagCollectionInfo', JSON.stringify(tagCollectionInfo));
  //点击新增一条集合，最外层的新增按钮
  // const handleAddCollectionlData = () => {
  //   tagCollectionInfo.push(initDetailForm());
  //   setTagCollectionInfo([...tagCollectionInfo]);
  // };
  //点击新增一条详细设置
  const handleAddRuleData = ({ id, type, originalDataType }) => {
    tagCollectionInfo.forEach((item) => {
      if (item.id === id) {
        if (type) {
          item.tagCollectionRuleIn.push({
            outsideSort: '',
            id: createId(),
            withinItem: originalDataType === 1 ? tagDom() : personDom(),
          });
        } else {
          item.tagCollectionRuleOut.push({
            outsideSort: '',
            id: createId(),
            withinItem: originalDataType === 1 ? tagDom() : personDom(),
          });
        }
        return;
      }
    });
    setTagCollectionInfo([...tagCollectionInfo]);
    setValue('tagCollectionInfo', JSON.stringify([...tagCollectionInfo]));
    setValue('tagCollectionRuleIn', JSON.stringify([...tagCollectionInfo]));
  };
  //点击新增一条详细设置的删除
  const handleAddRuleDataDelete = ({ tid, type, pid, wid }) => {
    tagCollectionInfo.forEach((item) => {
      if (item.id === pid) {
        //找到tagCollectionRuleIn、tagCollectionRuleOut
        let data = type ? item.tagCollectionRuleIn : item.tagCollectionRuleOut;
        data.forEach((it) => {
          if (it.id === tid) {
            it.withinItem = it.withinItem.filter((x) => x.id !== wid);
          }
          return;
        });
        if (type) {
          item.tagCollectionRuleIn =
            data && data.length > 0
              ? data.filter((y) => y.withinItem.length > 0)
              : [];
        } else {
          item.tagCollectionRuleOut =
            data && data.length > 0
              ? data.filter((y) => y.withinItem.length > 0)
              : [];
        }
        return;
      }
    });
    setTagCollectionInfo([...tagCollectionInfo]);
    setValue('tagCollectionInfo', JSON.stringify([...tagCollectionInfo]));
    setValue('tagCollectionRuleIn', JSON.stringify([...tagCollectionInfo]));
  };

  //点击新增一条详细规则设置， type===true是满足，
  const handleAddRuleDetailData = ({
    wid,
    pid,
    type,
    tid,
    originalDataType,
  }) => {
    tagCollectionInfo.forEach((item) => {
      if (item.id === pid) {
        //找到tagCollectionRuleIn、tagCollectionRuleOut
        const data = type
          ? item.tagCollectionRuleIn
          : item.tagCollectionRuleOut;
        data.forEach((it) => {
          if (it.id === tid) {
            it.withinItem.forEach((i) => {
              if (i.id === wid) {
                if (originalDataType === 1) {
                  i.originalDataList.push(createObj());
                } else {
                  i.originalDataList.push(createPersonObj());
                }
              }
            });
          }
          return;
        });
        return;
      }
    });
    setTagCollectionInfo([...tagCollectionInfo]);
    setValue('tagCollectionInfo', JSON.stringify([...tagCollectionInfo]));
    setValue('tagCollectionRuleIn', JSON.stringify([...tagCollectionInfo]));
  };

  //点击新增一条详细规则设置删除，type===true是满足， selfId最里面行id，wid是且id，pid详细设定id, tid是框id,
  const handleAddRuleDetailDataDelete = ({ wid, selfId, pid, type, tid }) => {
    tagCollectionInfo.forEach((item) => {
      if (item.id === pid) {
        const data = type
          ? item.tagCollectionRuleIn
          : item.tagCollectionRuleOut;
        data.forEach((it) => {
          if (it.id === tid) {
            it.withinItem.forEach((i) => {
              if (i.id === wid) {
                const newItem = i.originalDataList.filter(
                  (x) => x.id !== selfId,
                );
                i.originalDataList = newItem;
              }
            });
          }
          return;
        });
        return;
      }
    });
    setTagCollectionInfo([...tagCollectionInfo]);
    setValue('tagCollectionInfo', JSON.stringify([...tagCollectionInfo]));
    setValue('tagCollectionRuleIn', JSON.stringify([...tagCollectionInfo]));
  };
  const setFieldValue = (parameter) => {
    const { wid, selfId, pid, type, value, realName, id, tid } = parameter;
    tagCollectionInfo.forEach((item) => {
      if (item.id === id) {
        item[realName] = value;
        return;
      }
      if (item.id === pid) {
        const data = type
          ? item.tagCollectionRuleIn
          : item.tagCollectionRuleOut;
        data.forEach((it) => {
          if (it.id === tid) {
            it.withinItem.forEach((i) => {
              if (i.id === wid) {
                i.originalDataList.forEach((eIt) => {
                  if (eIt.id === selfId) {
                    eIt[realName] = value;
                    return;
                  }
                });
              }
            });
          }
          return;
        });
        return;
      }
    });
    setTagCollectionInfo([...tagCollectionInfo]);
    setValue('tagCollectionInfo', JSON.stringify([...tagCollectionInfo]));
    setValue('tagCollectionRuleIn', JSON.stringify([...tagCollectionInfo]));
  };

  //且里面的添加按钮
  const handleAddTagRuleData = ({ tid, pid, type, originalDataType }) => {
    tagCollectionInfo.forEach((item) => {
      if (item.id === pid) {
        const data = type
          ? item.tagCollectionRuleIn
          : item.tagCollectionRuleOut;
        data.forEach((it) => {
          if (it.id === tid) {
            originalDataType === 1
              ? it.withinItem.push(tagDomeItem())
              : it.withinItem.push(personDomItem());
          }
          return;
        });
        return;
      }
    });
    setTagCollectionInfo([...tagCollectionInfo]);
    setValue('tagCollectionInfo', JSON.stringify([...tagCollectionInfo]));
    setValue('tagCollectionRuleIn', JSON.stringify([...tagCollectionInfo]));
  };
  //删除最外层的卡片
  const handleDetailDelete = ({ id }) => {
    const newTagCollectionInfo = tagCollectionInfo.filter(
      (item) => item.id !== id,
    );
    if (typeof id === 'number') {
      deleteIds.push(id);
      setDeleteIds(deleteIds);
    }
    setTagCollectionInfo([...newTagCollectionInfo]);
    setValue('tagCollectionInfo', JSON.stringify([...newTagCollectionInfo]));
    setValue('tagCollectionRuleIn', JSON.stringify([...newTagCollectionInfo]));
  };
  //重置详细设置
  const handleRefreshDetail = ({ id }) => {
    tagCollectionInfo.forEach((item) => {
      if (item.id === id) {
        item.tagCollectionRuleIn = [];
        item.tagCollectionRuleOut = [];
      }
    });
    setTagCollectionInfo([...tagCollectionInfo]);
    setValue('tagCollectionInfo', JSON.stringify([...tagCollectionInfo]));
    setValue('tagCollectionRuleIn', JSON.stringify([...tagCollectionInfo]));
  };
  const handleSubmitData = () => {
    // setOpenError(true);
    setSaveOpen({
      status: true,
      tips: '确认保存当前所创建的内容？',
      title: '保存',
    });
  };
  //新建标签自定义按钮
  const initButton = () => {
    const buttonNode = (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '0 16px',
          width: '100%',
          marginBottom: '24px',
          marginRight: '24px',
        }}
      >
        <Button
          sx={{
            width: '100px!important',
          }}
          variant="contained"
          onClick={onCloseDialog}
          color="secondary"
        >
          取消
        </Button>
        <Button
          sx={{ width: '100px!important' }}
          variant="contained"
          onClick={onSaveLabelDialog}
        >
          确定
        </Button>
      </Box>
    );
    return { buttonNode, isShow: true, height: 'auto' };
  };

  const onSaveLabelDialog = () => {
    setSaveOpen({
      ...saveOpen,
      status: false,
    });
    if (saveOpen.title === '保存') {
      submitRef.current.click();
    } else if (saveOpen.title === '退出') {
      history.goBack();
    } else {
      dispatch({
        type: 'crowdCreateCopy/deleteLabel',
        payload: {
          values: {
            groupId: tagId,
          },
        },
        callback(res) {
          if (res.code === 0) {
            window.message.toast({
              type: 'success',
              message: '删除成功',
              title: '删除成功',
            });
            setTimeout(() => {
              history.goBack();
            }, 2000);
          }
        },
      });
    }
  };

  const onCloseDialog = () => {
    setSaveOpen({
      ...saveOpen,
      status: false,
    });
  };

  //预估人群
  const predict = () => {
    const formData = getValues();
    console.log({ tagCollectionInfo });
    if (
      !tagCollectionInfo ||
      (tagCollectionInfo &&
        tagCollectionInfo[0].tagCollectionRuleIn.length === 0)
    ) {
      setRule(true);
      return;
    }
    for (let i in formData) {
      if (
        i !== 'updateStrategy' &&
        i !== 'limitNumberQuantity' &&
        i !== 'isLimitNumberDownload' &&
        i !== 'title' &&
        i !== 'remark' &&
        (formData[i] === '' || formData[i] === null || formData[i].length === 0)
      ) {
        setRule(true);
        return;
      }
    }

    setRule(false);
    const newTagCollectionInfo = JSON.parse(JSON.stringify(tagCollectionInfo));
    const profileGroupRule = getFormData(newTagCollectionInfo, tagId);
    let values = {
      title: formData?.title,
      remark: formData?.remark,
      limitNumberQuantity: formData?.limitNumberQuantity,
      updateStrategy: Number(formData.updateStrategy),
      type: 2,
      isLimitNumberDownload: formData?.isLimitNumberDownload,
      status: 1,
      profileGroupRule,
    };
    setLoading(true);
    window.NE_DAWN.trigger(predictRef.current, {
      event: '_ec', // 事件名
      params: { ...values }, // 事件公参
    });
    dispatch({
      type: 'crowdCreateCopy/predict',
      payload: {
        values: values,
      },
      callback: (res) => {
        setLoading(false);
        if (res.code === 0) {
          window.message.toast({
            type: 'success',
            message: '预估成功',
            title: '预估成功',
          });
          setPredictNum(res.data);
        }
      },
    });
  };

  const cascadeCallBack = (params) => {
    const { value, wid, selfId, pid, type, id, tid, selectedItem } = params;
    if (value && Array.isArray(value) && value.length > 0) {
      const tId = value[value.length - 1];
      const ruleType = selectedItem[selectedItem.length - 1].ruleType;
      if (ruleType !== 1 && ruleType !== 5) {
        return;
      }
      dispatch({
        type: 'crowdCreateCopy/selectOption',
        payload: {
          values: {
            tagId: tId,
          },
        },
        callback: (res1) => {
          if (res1.code === 0) {
            const collect =
              res1.data.tagCollectionInfo?.map((item) => ({
                ...item,
                id: String(item.id),
              })) || [];
            tagCollectionInfo.forEach((item) => {
              if (item.id === id) {
                item.collectArr = collect;
                return;
              }
              if (item.id === pid) {
                const data = type
                  ? item.tagCollectionRuleIn
                  : item.tagCollectionRuleOut;
                data.forEach((it) => {
                  if (it.id === tid) {
                    it.withinItem.forEach((i) => {
                      if (i.id === wid) {
                        i.originalDataList.forEach((eIt) => {
                          if (eIt.id === selfId) {
                            eIt.collectArr = collect;
                            return;
                          }
                        });
                      }
                    });
                  }
                  return;
                });
                return;
              }
            });
          }
        },
      });
    }
  };
  const handleDelete = () => {
    setSaveOpen({
      status: true,
      tips: `确认删除“${getValues('title')}”标签？删除后将无法复原。`,
      title: '删除',
    });
  };
  useEffect(() => {
    const arr = isTagCollectionInfoWatch
      ? JSON.parse(isTagCollectionInfoWatch)
      : '';
    if (
      arr &&
      (arr[0].tagCollectionRuleIn.length > 0 ||
        arr[0].tagCollectionRuleOut.length > 0) &&
      errors.tagCollectionInfo
    ) {
      clearErrors('tagCollectionInfo');
    }
  }, [isTagCollectionInfoWatch, clearErrors]);

  useEffect(() => {
    const arr = isTagCollectionRuleInWatch
      ? JSON.parse(isTagCollectionInfoWatch)
      : '';
    if (
      arr &&
      arr[0].tagCollectionRuleIn.length > 0 &&
      errors.tagCollectionRuleIn
    ) {
      clearErrors('tagCollectionRuleIn');
    }
  }, [isTagCollectionRuleInWatch, clearErrors]);
  return (
    <LabelStyles>
      <Box
        data-log={JSON.stringify({
          oid: 'page_user_profile_management_edit',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
      >
        <Loading loading={loading || predictLoading}>
          <form onSubmit={handleSubmit(onSubmitSuccess, onSubmitError)}>
            <Box borderRadius="12px" bgcolor="background.paper" p={4}>
              <TitleML title="人群基本设置" fontSize="19px" p="0 0 32px 0" />
              <BasicML
                queryType={queryType}
                control={control}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                setError={setError}
                clearErrors={clearErrors}
              />
            </Box>
            <Box
              borderRadius="12px"
              bgcolor="background.paper"
              p={4}
              mt={0.5}
              mb={0.5}
            >
              <TitleML title="人群规则设置" fontSize="19px" p="0" />
              <div
                style={{ color: '#555', fontSize: 12, padding: '31px 0 24px' }}
              >
                <span style={{ color: 'red' }}>*</span>详细设置{' '}
                {errors.tagCollectionInfo ? (
                  <span style={{ color: '#f44336', fontSize: '12px' }}>
                    详细设置是必填项
                  </span>
                ) : (
                  ''
                )}
                <Box sx={{ height: '0px', overflow: 'hidden' }}>
                  <Controller
                    name="tagCollectionInfo"
                    control={control}
                    as={<>校验详细设置是否有值</>}
                    rules={{
                      validate: (v) => {
                        const vp = v ? JSON.parse(v) : '';
                        let status = true;
                        if (
                          !vp ||
                          (vp &&
                            vp[0].tagCollectionRuleIn.length === 0 &&
                            vp[0].tagCollectionRuleOut.length === 0)
                        ) {
                          status = false;
                        }
                        return status;
                      },
                    }}
                  />
                </Box>
                <Box sx={{ height: '0px', overflow: 'hidden' }}>
                  <Controller
                    name="tagCollectionRuleIn"
                    control={control}
                    as={<>校验详细设置是否有值</>}
                    rules={{
                      validate: (v) => {
                        const vp = v ? JSON.parse(v) : '';
                        let status = true;
                        if (
                          !vp ||
                          (vp && vp[0].tagCollectionRuleIn.length === 0)
                        ) {
                          status = false;
                        }
                        return status;
                      },
                    }}
                  />
                </Box>
              </div>
              <DetailML
                queryType={queryType}
                control={control}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                tagCollectionInfo={tagCollectionInfo} //详细设置的数据
                setError={setError}
                clearErrors={clearErrors}
                handleAddRuleData={handleAddRuleData}
                handleAddRuleDataDelete={handleAddRuleDataDelete}
                handleAddRuleDetailData={handleAddRuleDetailData}
                handleAddRuleDetailDataDelete={handleAddRuleDetailDataDelete}
                handleDetailDelete={handleDetailDelete}
                handleRefreshDetail={handleRefreshDetail}
                setFieldValue={setFieldValue}
                ruleLabelDirectoryList={ruleLabelDirectoryList} //级联数据
                handleAddTagRuleData={handleAddTagRuleData}
                cascadeCallBack={cascadeCallBack}
              />
              <Box className="line" sx={{ gap: '0 48px', display: 'flex' }}>
                <Box mt={2} className="preNumber">
                  <Box className="label_name">预估人数</Box>
                  <Box className="preNumber_detail">
                    {queryType === 'detail' || (
                      <LoadingButton
                        data-log={JSON.stringify({
                          oid: 'btn_user_profile_management_edit_estimate',
                          events: ['_ev'],
                          params: {
                            initUrl:
                              window.location.origin + window.location.pathname,
                          },
                        })}
                        ref={predictRef}
                        variant="contained"
                        size="small"
                        onClick={predict}
                        loading={loading}
                        loadingPosition="start"
                      >
                        预估
                      </LoadingButton>
                    )}
                    <Box className="num_count">{fmtThousand(predictNum)}人</Box>
                    {rule && (
                      <span
                        style={{
                          color: '#f44336',
                          fontSize: '.75rem',
                          display: 'inline-block',
                          marginLeft: '10px',
                          marginTop: '8px',
                        }}
                      >
                        您有未填项，请先填写后再预估
                      </span>
                    )}
                  </Box>
                </Box>
              </Box>
              <Box mt={2} className="setting_share">
                <Box className="label_name">人数限制</Box>

                <Box style={{ display: 'flex' }}>
                  <CheckBoxFieldCom
                    label="限制下载人数，随机返回"
                    name="isLimitNumberDownload"
                    defaultValue={false}
                    control={control}
                    queryType={queryType}
                    onCallBack={(e) => {
                      if (!e.target.checked) {
                        setValue('limitNumberQuantity', 0);
                      }
                    }}
                  />
                  <Controller
                    className="return_num"
                    defaultValue={0}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">人</InputAdornment>
                      ),
                    }}
                    as={
                      <TextField
                        variant="standard"
                        disabled={
                          !isLimitNumberDownloadWatch || queryType === 'detail'
                        }
                      />
                    }
                    name="limitNumberQuantity"
                    control={control}
                  />
                </Box>
              </Box>
            </Box>
            <Box
              borderRadius="12px"
              bgcolor="background.paper"
              p={4}
              mt={0.5}
              mb={0.5}
              className="button-wrap"
            >
              {queryType !== 'detail' && (
                <LoadingButton
                  variant="contained"
                  onClick={handleSubmitData}
                  loading={isLoading}
                  loadingPosition="start"
                  startIcon={
                    <DoneIcon sx={{ width: '16px', height: '16px' }} />
                  }
                  sx={{ marginRight: '16px' }}
                >
                  保存
                </LoadingButton>
              )}
              {queryType === 'edit' && (
                <Button
                  data-log={JSON.stringify({
                    oid: 'btn_user_profile_management_edit_delete',
                    events: ['_ev', '_ec'],
                    params: {
                      initUrl:
                        window.location.origin + window.location.pathname,
                    },
                  })}
                  style={{
                    marginRight: '15px',
                    backgroundColor:
                      userAuths.indexOf('OPT_PROFILE_TAG_DELETE') > -1
                        ? '#CA2C21'
                        : '#F5F5F5',
                    color:
                      userAuths.indexOf('OPT_PROFILE_TAG_DELETE') > -1
                        ? '#fff'
                        : '#ccc',
                  }}
                  variant="contained"
                  className="cancel"
                  startIcon={
                    <DeleteIcon sx={{ width: '16px', height: '16px' }} />
                  }
                  onClick={
                    userAuths.indexOf('OPT_PROFILE_TAG_DELETE') > -1 &&
                    handleDelete
                  }
                >
                  删除
                </Button>
              )}
              <Button
                variant="contained"
                color="secondary"
                className="cancel"
                startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
                onClick={() => handleClickOpen()}
              >
                退出
              </Button>
            </Box>
            <Button
              data-log={JSON.stringify({
                oid: 'btn_user_profile_management_edit_save',
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              sx={{ display: 'none' }}
              type="submit"
              ref={submitRef}
            ></Button>
          </form>
        </Loading>
        <DialogDataML
          open={saveOpen.status}
          title={
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <span
                style={{ fontSize: '18px', fontWeight: 600, color: '#212121' }}
              >
                {saveOpen.title}
              </span>
            </Box>
          }
          content={<Box sx={{ width: '336px' }}>{saveOpen.tips}</Box>}
          handleClose={onCloseDialog}
          button={initButton()}
        />
      </Box>
    </LabelStyles>
  );
};
